import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Back from "assets/images/svg/back_blue.svg";
import Master from "assets/images/svg/master_incard.svg";
import Visa from "assets/images/svg/visa_intable.svg";
import Paypal from "assets/images/svg/paypal_intable.svg";
import cancel from "assets/images/svg/cancel.svg";
import DeleteMethod from "./component/deleteMethod";
import { useModal } from "hooks";
import NewCard from "./component/newCard";
import { useTranslation } from "react-i18next";
import { useCardsToken, usePayMethods } from "hooks/use-pay-method";
import moment from "moment";
import _paymentService from "services/payment-services";
import { Spinner } from "react-bootstrap";
import { useAuthContext } from "store/auth";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";

const PaymentSetting = () => {
  const { t } = useTranslation("browse-apps");
  const { cards, isLoading } = useCardsToken();
  const { payMethods } = usePayMethods();

  const paypalObj = payMethods?.find((p) => p?.paymentType?.name === "Paypal") ?? {};
  const fawrylObj = payMethods?.find((p) => p?.paymentType?.name === "Fawry") ?? {};
  const visaObj = payMethods?.find((p) => p?.paymentType?.name === "Visa") ?? {};

  const [searchParams] = useSearchParams();
  const [{ user }] = useAuthContext();
  const queryClient = useQueryClient();

  const [showDeleteMethod, openDeleteMethod, closeDeleteMethod] = useModal(false);
  const [cardId, setCardId] = useState();

  const token = searchParams.get("token");
  const statusCode = searchParams.get("statusCode");
  const statusDescription = searchParams.get("statusDescription");
  const creationDate = searchParams.get("creationDate");
  const lastFourDigits = searchParams.get("lastFourDigits");
  const firstSixDigits = searchParams.get("firstSixDigits");

  let defaultCard = cards?.find((c) => c.isDefault)?.id;
  const [selectedCard, setSelectedCard] = useState(defaultCard);

  const getCardIcon = (CardType) => {
    switch (CardType) {
      case "Visa Card":
        return Visa;
      case "BMISCARD":
        return Visa;
      case "MasterCard":
        return Master;
      default:
        break;
    }
  };

  const handleCardChange = (e,id) => {
    setSelectedCard(e.target.value);
    setCardId(id);
  };

  const addCard = () => {
    _paymentService
      .createCardToken({
        returnUrl: window.location.href,
        paymentMethodId: fawrylObj?.id
      })
      .then(({ response }) => {
        sessionStorage.setItem('paymentMethodId',fawrylObj?.id)
        window.location.href = response;
      });
  };

  const getId = (id) => {
    setCardId(id);
    openDeleteMethod();
  };

  const deleteCard = () => {
    _paymentService.deleteCardToken(fawrylObj?.id, cardId).then(() => {
      toast.success(t('common:form.removed'))
      queryClient.invalidateQueries(["cards"]);
      closeDeleteMethod();
    });
  };
  const updateCard = () => {
    _paymentService
      .updateCardToken({
        isDefault: true,
        id: selectedCard
      })
      .then(() => {
        toast.success(t('common:form.updated'))
        queryClient.invalidateQueries(["cards"]);
      });
  };
  let CardInfoDTO = {
    customerId: user?.Id,
    token: token,
    statusCode: statusCode,
    statusDescription: statusDescription,
    lastFourDigits: lastFourDigits,
    firstSixDigits: firstSixDigits,
    creationDate: creationDate
  };
  useEffect(() => {
    if (token && payMethods ) {
      _paymentService.addCardToken({...CardInfoDTO,paymentMethodId: sessionStorage.getItem('paymentMethodId')}).then(() => {
        queryClient.invalidateQueries(["cards"]);
       // window.open(window.location.origin+window.location.pathname)
        // if (token) {
        //   window.location;
        // } else {
        //   queryClient.invalidateQueries(["cards"]);
        // }
      });
    }
  }, []);
  
useEffect(()=>{
  if(!selectedCard) setSelectedCard(defaultCard)
},[])
  return (
    <div className="paymentSetting">
      <div className="header">
        <Link to="/invoices">
          <img className="back" src={Back} alt="back" />
        </Link>
        <h1 className="title">{t("paymentDetails.paySetting")}</h1>
      </div>
      <hr className="hr" />
      <div className="row">
        <div className="col-xl-5 col-lg-8 col-md-12">
          <div className="savedCards">
            <h2 className="title">{t("paymentDetails.savedCards")}</h2>
            {isLoading && (
              <div className="my-center">
                <Spinner animation="grow" variant="primary" />
              </div>
            )}
            {cards?.map((c) => (
              <div key={c.id} className="card-box" id={c.cardNumber}>
                <label className="label" onChange={(e) => handleCardChange(e,c.id)}>
                  <input type="radio" name="card" value={c?.id} defaultChecked={c.isDefault} />
                  <span className="info" >
                    <div className="left-side">
                      <img className="visa" src={getCardIcon(c?.extraInfo)} alt="visa" />
                      <p>
                        {c?.brand} - {moment(c.creationDateTime).format("MM/YY")}
                      </p>
                    </div>
                    <div className="right-side">
                      <p>{c?.cardNumber}</p>
                    </div>
                  </span>
                </label>
                <img className="cancel" src={cancel} alt="cancel" onClick={() => getId(c.cardToken)} />
                {/* <div className="right-side">
                  <img className="cancel" src={cancel} alt="cancel" onClick={() => getId(c.token)} />
                </div> */}
              </div>
            ))}

            <button className="btn-blue-light" onClick={addCard}>
              {t("paymentDetails.cardForm.add")}{" "}
            </button>

            {cards?.length > 0 && (
              <button className="btn-blue" onClick={updateCard}>
                {t("paymentDetails.cardForm.save")}
              </button>
            )}
            {/* <h2 className='title'>Paypal</h2>
                        <label className='label'>
                            <input type="radio" name="card" id="visa"/>
                            <span className='info'>
                                <div className='left-side' >
                                    <img className="visa" src={Paypal} alt="visa" />
                                    <p>xi**5@li**a.com</p>
                                </div>
                                <div className='right-side' >
                                    <img className='cancel' src={cancel} alt="cancel" onClick={openDeleteMethod}/>
                                </div>
                            </span>
                        </label>

                        <button className='btn-blue-light'>Link A Paypal Account</button>
                        <button className='btn-blue'>save</button> */}
          </div>
        </div>
      </div>
      <DeleteMethod show={showDeleteMethod} onHide={closeDeleteMethod} onDelete={deleteCard} />
      {/* <NewCard show={showNewCard} onHide={closeNewCard} /> */}
    </div>
  );
};

export default PaymentSetting;
